export default "__VITE_ASSET__nALKmS_C__"